import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  OnDestroy,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService, DocumentService, NotifyAssociationDocumentUpdateService, NotifyLinkedItemsUpdateService } from '@app/shared/services';
import { map, startWith } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import * as moment from 'moment';
import { AddDocumentComponent } from '../add-document.component';
import { ViewTemplateComponent } from '@app/shared/component/view-template/view-template.component';
import { Subscription } from 'rxjs';
import { TaskDialogComponent } from '../../dialogs/task-dialog/task-dialog.component';
import { TaskService } from '@app/shared/services/task/task.service';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import * as loginSelectors from '../../../../../root-store/login-store/login.selector';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-asset-form-association',
  templateUrl: './add-asset-form-association.component.html',
  styleUrls: ['./add-asset-form-association.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddAssetFormAssociationComponent implements OnInit, OnDestroy {
  @Input() currentFormId;

  showSearchBar = false;
  @Input() currentValutUserId;
  @Input() formName;
  @Input() mode;
  @Input() sharingMode;
  @Input() isRemoveEditSaveSharing;
  @Input() currentuserId;
  @Input() data;
  @Input() origin;
  imageSrc: any = '';
  panelOpenState: boolean = true;
  currentUser: any;
  customStyle = {
    width: '26px',
    cursor: 'pointer',
  };
  isDataLoading = true;
  screenWidth: number;
  environment = environment;
  subscription = new Subscription();
  locationDatalist: Array<any> = [];
  totallocationDatalist: Array<any> = [];
  selectedUser: Array<any> = [];
  currentAddedData: Array<any> = [];
  parent_vault_user_location_id;
  allowEditPermission = true;
  formatAddedData = [];
  associationForm = new UntypedFormControl();
  isUserSelected = false;
  delete = false;

  sharedData: Array<any> = [];
  currentdataLength: number;

  // vault state object
  vaultStateObject;
  stateObject;
  vaultStateObject$: any;
  @Output() recordassociationCount: EventEmitter<any> = new EventEmitter<any>();
  associationCount = 0;
  drawerButtonClicked = false;
  is_filter;
  is_filter_name;
  noMatchFound = false;
  searchText = false;

  constructor(
    private documentService: DocumentService,
    private router: Router,
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private taskService: TaskService,
    private dialog: MatDialog,
    private elementRef: ElementRef,
    private notifyAssociationDocumentUpdateService: NotifyAssociationDocumentUpdateService,
    public dialogRef: MatDialogRef<AddAssetFormAssociationComponent>,
    private vaultService: VaultStoreEffects,
    private _notifyLinkedItemsUpdateService: NotifyLinkedItemsUpdateService,
    private _store: Store
  ) {
    this.screenWidth = window.innerWidth;

    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
      })
    );
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        } else {
          this.currentUser = null;
          router.navigate(['/']);
        }
      })
    );
    this.vaultStateObject$ = this.vaultService.vaultObject;
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.cd.markForCheck();
      })
    );
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.showSearchBar = false;
    }
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onClickedOutside(e: Event) {
    this.showSearchBar = false;
  }
  ngOnInit() {
    if (this.router.url.includes('network') && !this.router.url.includes('admin=true') && this.origin == 'vault') {
      this.allowEditPermission = false;
    }

    // form Filter
    this.subscription.add(
      this.associationForm.valueChanges
        .pipe(
          startWith(''),
          map((value) => this.filter(value))
        )
        .subscribe((response) => {
          if (response.length == 0 && this.searchText) {
            this.noMatchFound = true;
          } else {
            this.noMatchFound = false;
          }
          this.locationDatalist = response;
          this.cd.detectChanges();
        })
    );
    if (this.data.user_id) {
      // this.getUserFormAssociation(this.vaultStateObject.userId, this.currentFormId);
    } else {
      this.getFormUserFormAssociation();
    }
  }

  private filter(value) {
    if (this.totallocationDatalist && value?.toLowerCase().length && value.length != 0) {
      this.searchText = true;
      return this.totallocationDatalist.filter(
        (user) => user?.form_name?.toLowerCase().includes(value?.toLowerCase()) || user?.name?.toLowerCase().includes(value?.toLowerCase())
      );
    } else {
      this.searchText = false;
      return this.totallocationDatalist;
    }
  }
  checkAccessibility(date): string {
    const formatedDate = moment().utc();

    if (date) {
      const diffInDays = moment(date).diff(formatedDate, 'hours');

      if (diffInDays <= 0) {
        return 'now';
      }

      if (diffInDays > 0) {
        return 'sealed';
      }
    } else {
      return 'later';
    }
  }
  checkAccessibilityTag(date): string {
    const formatedDate = moment().utc();

    if (date) {
      const diffInDays = moment(date).diff(formatedDate, 'hours');

      if (diffInDays <= 0) {
        return 'Accessible Now';
      }

      if (diffInDays > 0) {
        return 'Accessible on ';
      }
    } else {
      return 'Accessible Later';
    }
  }
  clearAutoCompleteValue() {
    this.associationForm.setValue('');
  }

  viewModal(file, event?: any) {
    this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: {
        file: file,
        mode: 'edit',
        isintelligent: false,
        isfileListLoad: true,
      },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });
  }
  togglePanel(event, title, name) {
    const dialogRef = this.dialog.open(ViewTemplateComponent, {
      data: {
        categoryType: 'vault',
        isLinked: true,
        is_linked_form_id: this.currentFormId,
        Linked_form_name: this.formName,
        is_filter: title,
        is_filter_name: name,
      },
      panelClass: 'full-window-dialog',
      disableClose: true,
    });
  }
  deletePhone(event) {
    this.isDataLoading = false;
    this.drawerButtonClicked = false;
    this.cd.detectChanges();
  }
  getFormUserFormAssociation() {
    if (this.vaultStateObject.userId) {
      // this.subscription.add(
      //   this.documentService.getUserLocationList(this.vaultStateObject.userId, this.vaultStateObject.vaultId).subscribe((res) => {
      //     this.isDataLoading = false;
      //     this.drawerButtonClicked = false;
      //     this.locationDatalist = this.totallocationDatalist = res.locations;
      //     this.cd.detectChanges();
      //   })
      // );
    }
  }
  processFullList(res) {
    this.isDataLoading = false;
    this.drawerButtonClicked = false;

    this.locationDatalist = this.totallocationDatalist = res.filter((x) => x.template_is?.toLowerCase().includes('asset'));
    this.cd.detectChanges();
  }

  openInviteDialog() {
    this.showSearchBar = false;
  }
  selectAssociatedUser($event, data) {
    this.showSearchBar = false;
    this.selectedUser = data;
    this.isUserSelected = true;
    if (data?.vault_form_id) {
      // create
      const payload = {
        user_id: +this.currentUser.id,
        vault_user_form_id: this.currentFormId,
        created_by_user_id: this.vaultStateObject.userId,
        association_type: 'asset',

        associate_vault_user_form_id: this.selectedUser['id'],
      };
      if ((this.router.url.includes('/checklist/') || this.router.url.includes('/reports/')) && this.currentValutUserId) {
        payload.user_id = this.currentValutUserId;
      }

      this.subscription.add(
        this.documentService.createUserFormAssociation(payload).subscribe((result) => {
          this.subscription.add(this.notifyAssociationDocumentUpdateService.sendMessage(true));

          // this.getUserFormAssociation(this.vaultStateObject.userId, this.currentFormId);

          // refresh modal
          this.cd.markForCheck();
        })
      );
    } else {
      const request = {
        id: data.id,
        linked_item: [this.currentFormId],
      };
      this.updateLinkedForm(request);
    }
  }
  precesslistData(result) {
    this.isDataLoading = false;
    result = result.filter((x) => x.association_type == 'asset');

    this.currentAddedData = result;
    this.formatAddedData = result;
    this.delete = false;
    if (this.currentdataLength >= 1 && !this.delete && this.isUserSelected) {
      this.associationCount++;
      this.recordassociationCount.emit(this.associationCount);
    }
    this.isUserSelected = false;
    this.clearAutoCompleteValue();
    // refresh modal
    this.cd.markForCheck();
  }
  selectedOption(event) {}
  getUserFormAssociation(userId, currentFormId) {
    if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
      userId = this.currentuserId;
    }
    this.subscription.add(
      this.documentService.getUserFormAssociation(userId, currentFormId).subscribe((result) => {
        this.precesslistData(result);
      })
    );
  }

  // not used
  // openDrawerEvent(categoryId, categoryName) {
  //   this.commonService.toggle(true);
  //   this.drawerButtonClicked = true;
  //   this.is_filter = categoryId;
  //   this.is_filter_name = categoryName;
  //   this.cd.detectChanges();
  // }

  getFormData(id) {
    if (this.stateObject && this.stateObject.forms) {
      return this.stateObject.forms.filter((form) => form.id == id);
    }
  }

  updateLinkedForm(request) {
    this.subscription.add(
      this.taskService.updateTask(request).subscribe((result) => {
        this.getFormUserFormAssociation();
        this.cd.markForCheck();
      })
    );
  }

  deleteUserFormAssociation(id, form_name, item) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        imageSrc: 'assets/images/attachment.svg',
        title: 'Remove Asset',
        materialIcon: 'attachment',
        text: `Are you sure you want to remove ${form_name}?`,
        proceedTitle: 'Remove',
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (form_name != null && form_name != undefined) {
            this.subscription.add(
              this.documentService.deleteUserFormAssociation(this.vaultStateObject.userId, item.formid, item.associatedformid).subscribe((result) => {
                this.delete = true;
                this.subscription.add(this.notifyAssociationDocumentUpdateService.sendMessage(true));
                this.cd.markForCheck();
              })
            );
          } else {
            const request = {
              id: id,
              linked_item: [],
            };
            this.updateLinkedForm(request);
          }
        }
      })
    );
  }
  setCustomPosition() {
    var output = document.getElementById('add-asset-form-association-container').getBoundingClientRect();
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      eval(`document.getElementById('add-asset-form-association-search-box').style.top ='${+output.y.toFixed() + 78}px';`);
    }, 0);
  }
}
